import { FeatureFlagsContext } from './feature-flags.context';
import { FC, ReactNode, useCallback, useEffect } from 'react';
import { useService } from '../ioc-container/use-service.hook';
import { useTimer } from '../hooks/use-timer';
import { AuthService } from '../auth/auth.service.ts';
import { observer } from 'mobx-react-lite';
import { FeatureFlags } from './feature-flags-state.ts';

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export interface FeatureFlagsProviderProps {
	children: ReactNode;
}

export const FeatureFlagsProvider: FC<FeatureFlagsProviderProps> = observer(({ children }) => {
	const authService = useService<AuthService>(AuthService);
	const featureFlagsState = useService<FeatureFlags>(FeatureFlags);

	const fetchFlags = useCallback(() => {
		featureFlagsState.refresh();
		// We want this to be executed again when the user is authenticated, as the flags might change by the user
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [featureFlagsState, authService.authenticated]);

	useEffect(fetchFlags, [fetchFlags]);
	useTimer(fetchFlags, 5 * MINUTE);

	return (
		<FeatureFlagsContext.Provider value={featureFlagsState.flags}>
			{children}
		</FeatureFlagsContext.Provider>
	);
});
